/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Analytics_Inputtokens1Inputs */

const zh_analytics_inputtokens1 = /** @type {(inputs: Analytics_Inputtokens1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`输入 Tokens`)
};

const en_analytics_inputtokens1 = /** @type {(inputs: Analytics_Inputtokens1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Input Tokens`)
};

const es_analytics_inputtokens1 = /** @type {(inputs: Analytics_Inputtokens1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tokens de entrada`)
};

/**
* | output |
* | --- |
* | "Input Tokens" |
*
* @param {Analytics_Inputtokens1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const analytics_inputtokens1 = /** @type {((inputs?: Analytics_Inputtokens1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Analytics_Inputtokens1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_analytics_inputtokens1(inputs)
	if (locale === "en") return en_analytics_inputtokens1(inputs)
	return es_analytics_inputtokens1(inputs)
});
export { analytics_inputtokens1 as "analytics_inputTokens" }